<template>
  <div class="preview-video">
    <iframe
      ref="video"
      :src="videoLectureParseUrl"
      frameborder="0"
      width="100%"
      height="100%"
      webkitallowfullscreen
      mozallowfullscreen
      allowfullscreen
      fullscreen
      allow="autoplay"
    />
  </div>
</template>

<script>
import { head } from 'lodash';
import { parse } from 'himalaya';

export default {
  name: 'preview-video',

  props: {
    url: {
      type: String,
    },
  },

  data() {
    return {
      player: null,
    };
  },

  computed: {
    videoLectureParse() {
      return head(parse(this.url)).attributes;
    },

    videoLectureParseUrl() {
      return `${this.videoLectureParse.src}&autoplay=1`;
    },

  },
};
</script>

<style lang="scss" scoped>
  .preview-video {
    overflow: hidden;
    padding-bottom: 56.25%;
    position: relative;
    height: 0;

    iframe {
      height:100%;
      width:100%;
      top:0;
      left:0;
      right:0;
      bottom:0;
      position:absolute;
    }
  }

</style>
